import { useContext } from 'react';
import { permission } from '../containers/admin/Secure/permission';
import { UserCtx } from '../contexts/UserCtx';

// Export all permissions here in order to reduce the number of imports required to do a permissions check
export const allPermissions = permission;

// Flatten the permissions object into an array of titles
const allPermissionTitles = Object.values(permission).flatMap((group) => Object.values(group));

/**
 * Does the specified permission exist
 */
const permissionExists = (permissionTitle = '') => {
  if (!permissionTitle) return false;
  return allPermissionTitles.includes(permissionTitle);
};

/**
 * Evaluate whether the current user has permission to perform an action
 * @param {string} requiredPermission An entry from the `permission` object in the Secure directory
 * @returns {boolean}
 */
export const hasPermission = (requiredPermission = '') => {
  // Deny Access if the specified permission doesn't exist
  if (!permissionExists(requiredPermission)) return false;

  // Check the users has the specified permission
  const userCtx = useContext(UserCtx);
  return userCtx.hasPermission(requiredPermission);
};
